module.exports = __webpack_public_path__ + "img/Weapon_44.38dec0f0.png";